export type AttendancePolicyStatus = "SCHEDULED" | "ATTENDED" | "STUDENT_LEAVE" | "STUDENT_ABSENT";

export function shouldDeductByPolicy(status: AttendancePolicyStatus): boolean {
  return status === "SCHEDULED" || status === "ATTENDED" || status === "STUDENT_ABSENT";
}

export function canAttendFromHours(beforeHours: number, deductHours: number): boolean {
  return beforeHours >= deductHours;
}
